// mobile-screen-switch-cart-badge-count.js

(function () {
    // Reload when coming back via swipe/back-forward cache
    window.addEventListener('pageshow', function (e) {
        if (e.persisted) location.reload();
    });
    // Also reload on back/forward navigation (some browsers)
    window.addEventListener('popstate', function () {
        location.reload();
    });
})();
